import React, { useEffect } from 'react';
import checkoutBannerImg from '../../utils/assets/checkout/checkout.png';
import WelcomeSection from '../../shared/components/WelcomeSection/WelcomeSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import PaymentInfo from '../components/PaymentInfo/PaymentInfo';
const Checkout = () => {

    useEffect(()=>{
        window.scroll(0,0);
    },[])
    const bannerSectionInfo =
    {
       cardTitle: "Now you are ready to invest in your pet's care",
       cardButtonText: "",
       lengendBackground: checkoutBannerImg
    }

    return (
        <React.Fragment>
           {/* <WelcomeSection props={bannerSectionInfo}/>
           <NavegationInfo page="Checkout"/> */}
           <PaymentInfo/>
        </React.Fragment>
    );
};

export default Checkout;
           